import AppEnvironment from '../../components/enums/appEnvironment.enum';
import { useAppEnvironmentStore } from '../../stores/AppEnvironment/appEnvironment.store';

export default function getRoutePrefix(): string {
  const { appEnvironment } = useAppEnvironmentStore.getState();

  if (appEnvironment === AppEnvironment.STORE) {
    return '/store';
  }

  return '';
}
